import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate, useLocation } from 'react-router-dom';
import { RiMenu3Line } from 'react-icons/ri';
import layoutStyles from '../../styles/layout.module.css';
import styles from './Navbar.module.css';

const Navbar: React.FC = () => {
  const { i18n, t } = useTranslation();
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  const changeLanguage = (lng: string) => {
    i18n.changeLanguage(lng);
  };

  const scrollToSection = (e: React.MouseEvent, sectionId: string) => {
    e.preventDefault();
    setIsMenuOpen(false); // Close mobile menu after clicking

    if (location.pathname !== '/') {
      navigate('/', { state: { scrollTo: sectionId } });
      return;
    }

    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });
    }
  };

  return (
    <nav className={styles.colorWrapper}>
      <div className={`${layoutStyles.container} ${styles.nav}`}>
        <div className={styles.logo}>
          <img className={styles.logoIcon} src="/logo_jbp_nofondo.png" alt="JBP SOFTWARE" />
        </div>
        <div className={styles.navLinksContainer}>
          <div className={`${styles.navLinks} ${isMenuOpen ? styles.showMobile : ''}`}>
            <a onClick={(e) => scrollToSection(e, 'AboutUs')} href="#AboutUs">{t('navigation.aboutUs')}</a>
            <a onClick={(e) => scrollToSection(e, 'OurWork')} href="#OurWork">{t('navigation.ourWork')}</a>
            <a onClick={(e) => scrollToSection(e, 'OurServices')} href="#OurServices">{t('navigation.ourServices')}</a>
            <a onClick={(e) => scrollToSection(e, 'OurProcess')} href="#OurProcess">{t('navigation.ourProcess')}</a>
            <a onClick={(e) => scrollToSection(e, 'Recognitions')} href="#Recognitions">{t('navigation.recognitions')}</a>
            <a onClick={(e) => scrollToSection(e, 'NewIdeas')} href="#NewIdeas">{t('navigation.newIdeas')}</a>
          </div>
          <div className={styles.actions}>
            <div className={styles.langSwitch}>
              <button 
                onClick={() => changeLanguage('en')}
                className={i18n.language === 'en' ? styles.selected : ''}
              >
                EN
              </button>
              <button 
                onClick={() => changeLanguage('es')}
                className={i18n.language === 'es' ? styles.selected : ''}
              >
                ES
              </button>
            </div>
          </div>
          <button 
            className={styles.menuButton}
            onClick={() => setIsMenuOpen(!isMenuOpen)}
          >
            {React.createElement(RiMenu3Line as any, { size: 24 })}
          </button>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
